import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/collaborall.webp';
import screenshot_target from '../../../images/letterfunnel/peterkleinjan.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Peter Kleinjan"
      firstname="Peter"
      companyname="Collaborall"
      competition="Cadac Group en Relatics"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/peterkleinjan.js